import { render, staticRenderFns } from "./order-recharge-form.vue?vue&type=template&id=2e8cd48d&scoped=true"
import script from "./order-recharge-form.vue?vue&type=script&lang=js"
export * from "./order-recharge-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cd48d",
  null
  
)

export default component.exports